import type {MetrikaArguments, YandexMetrika} from "./metrik.types";

const METRIKA_SCRIPT_URL = "https://mc.yandex.ru/metrika/tag.js";

function loadMetrika(): void {
  if (!window.ym) {
    const queue: YandexMetrika = (...args: MetrikaArguments): void => {
      (queue.a ??= []).push(args);
    };
    window.ym = queue;
  }
  window.ym.l = Date.now();

  if (
    Array.from(document.scripts).some(
      (script) => script.src === METRIKA_SCRIPT_URL
    )
  ) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = METRIKA_SCRIPT_URL;
  const firstScript = document.scripts[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
}

export function reachGoal(id: number, goal: string): void {
  window.ym?.(id, "reachGoal", goal);
}

export function addMetrik(arrId: (number | string)[]): void {
  loadMetrika();

  arrId.forEach((id, num) => {
    window.ym?.(Number(id), "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: num === 0 && id !== "106353501"
    });

    window.ym?.(Number(id), "hit");
  });
}
export function getYMCID(): string | false {
  var match = document.cookie.match("(?:^|;)\\s*_ym_uid=([^;]*)");
  if (!match) {
    return false;
  }

  let matchInt = match.map((a) => {
    return a.replace(/\D/g, "");
  });
  return "_ym_uid=" + Array.from(new Set(matchInt)).join(" ");
}
